import * as React from "react";

const SvgUnSync = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="currentColor"
    viewBox="0 0 24 24"
  >
    <path
      fill="currentColor"
      fillOpacity={0.92}
      d="m9 20-1.4-1.425L10.175 16H3v-2h7.175L7.6 11.425 9 10l5 5z"
    />
    <path
      fill="currentColor"
      d="m16 3 1.4 1.425L14.825 7H22v2h-7.175l2.575 2.575L16 13l-5-5z"
    />
  </svg>
);
export default SvgUnSync;
